import api from './axios';
import { Product, InventoryMovement, DashboardStats, MovementChartData } from '../types';

export const reportsApi = {
  getDashboardStats: () => api.get<DashboardStats>('/reports/dashboard'),

  getMovementChart: () => api.get<MovementChartData[]>('/reports/movements-chart'),

  getStockReport: () => api.get<Product[]>('/reports/stock'),

  getMovementsReport: (params?: { startDate?: string; endDate?: string; type?: string }) =>
    api.get<InventoryMovement[]>('/reports/movements', { params }),

  getLowStockReport: () => api.get<Product[]>('/reports/low-stock'),

  getDishesSold: (params?: { from?: string; to?: string }) =>
    api.get('/reports/dishes-sold', { params }),

  getAntitheft: (from?: string, to?: string) =>
    api.get('/reports/antitheft', { params: { from, to } }),

  getServiceTimes: (params?: { from?: string; to?: string }) =>
    api.get('/reports/service-times', { params }),
};
